import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from "react";
import { CompetitionResultResource } from "@ploy-lib/rest-resources";
import { DataTable } from "@ploy-ui/core";
import { Box, makeStyles } from "@material-ui/core";
import useResizeObserver from "use-resize-observer/polyfilled";
import { allColumns } from "./Competitions";
import Skeleton from "@material-ui/lab/Skeleton";
import { useStatefulResource } from "@rest-hooks/legacy";
import clsx from "clsx";
import { columnTitleMessages } from ".";
import { useIntl } from "react-intl";
import { isNotNull } from "@ploy-lib/core";
CompetitionResult.displayName = "CompetitionResult";
const useStyles = makeStyles(theme => ({
    scroll: {
        overflowY: "scroll"
    },
    noScroll: {
        overflow: "hidden",
        display: "grid"
    }
}));
export function CompetitionResult(props) {
    const { visibleColumns, competitionId, placeholder, scrollable } = props;
    const classes = useStyles();
    const animation = !placeholder && undefined;
    const placeholderData = useMemo(() => [
        {
            competitionId: ".",
            position: 1,
            salespersonName: (_jsx(Skeleton, { animation: animation, variant: "text", width: "10ch" })),
            vendor: _jsx(Skeleton, { animation: animation, variant: "text", width: "8ch" })
        }
    ], [animation]);
    const { data: results = placeholderData, loading } = useStatefulResource(CompetitionResultResource.list(), !placeholder && competitionId ? { competitionId } : null);
    const intl = useIntl();
    // Ordered by properties order (ordering not implemented in editor)
    // const columns = useMemo(
    // 	() =>
    // 		(!placeholder ? visibleColumns : Object.keys(placeholderData[0]))
    // 			?.map(name =>
    // 				allColumns.find(
    // 					c => c.field?.toString().toLowerCase() === name.toLowerCase()
    // 				)
    // 			)
    // 			.filter(isNotNull) ?? allColumns,
    // 	[placeholder, placeholderData, visibleColumns]
    // );
    const columns = useMemo(() => {
        const visibleNames = (!placeholder ? visibleColumns : Object.keys(placeholderData[0]))?.map(n => n.toLowerCase());
        let baseColumns = visibleNames
            ? visibleNames
                .map(x => allColumns.find(ac => typeof ac.field === "string" && ac.field?.toLowerCase() === x))
                .filter(isNotNull)
            : allColumns;
        baseColumns.forEach(col => {
            if (typeof col.field !== "string")
                return;
            const field = col.field;
            const fieldLower = field.toLowerCase();
            const isBudget = fieldLower === "budgetpercentage"; // budgetpercentage is the budget column
            const isPoints = fieldLower === "score"; // score is the points column
            // If its not budget or points column we always include it
            if (!isBudget && !isPoints)
                return;
            const hasValue = results.some(row => {
                const val = row[field];
                return val !== null && val !== undefined && val !== "" && val !== 0;
            });
            if (isBudget)
                col._isBudget = true;
            if (isPoints)
                col._isPoints = true;
            col._hasValue = hasValue;
        });
        const budgetCol = baseColumns.find(col => col._isBudget);
        const pointsCol = baseColumns.find(col => col._isPoints);
        const hideBudget = budgetCol && !budgetCol._hasValue;
        const hidePoints = pointsCol && !pointsCol._hasValue;
        // If both budget and points are empty or 0, we show both columns
        if (hideBudget && hidePoints) {
        }
        else {
            baseColumns = baseColumns.filter(col => {
                if (col._isBudget)
                    return !hideBudget;
                if (col._isPoints)
                    return !hidePoints;
                return true;
            });
        }
        return baseColumns.map(c => ({
            ...c,
            title: typeof c.field === "string"
                ? intl.formatMessage(columnTitleMessages[c.field])
                : c.title
        }));
    }, [intl, placeholder, placeholderData, visibleColumns, results]);
    const tableRef = useRef();
    const { ref } = useResizeObserver({
        onResize: ({ height = 0 }) => {
            const maxRows = Math.floor((height - 57) / 53);
            const pageSize = Math.max(maxRows - 1, 1);
            if (tableRef.current?.state.pageSize !== pageSize)
                tableRef.current?.onRowsPerPageChange({ target: { value: pageSize } });
        }
    });
    return (_jsx(Box
    // @ts-expect-error: No overload matches this call. (https://github.com/mui-org/material-ui/issues/17010)
    , { 
        // @ts-expect-error: No overload matches this call. (https://github.com/mui-org/material-ui/issues/17010)
        ref: ref, flexGrow: 1, className: clsx({
            [classes.scroll]: scrollable,
            [classes.noScroll]: !scrollable
        }), children: _jsx(DataTable, { tableRef: tableRef, options: {
                showTitle: false,
                search: false,
                paging: !scrollable,
                toolbar: false,
                pageSize: 2,
                pageSizeOptions: [5, 10]
            }, isLoading: loading, columns: columns, data: results }) }));
}
//# sourceMappingURL=CompetitionResult.js.map